/**
 * Enveloppe de mise en page qui ajoute le pied de page légal sous la page.
 *
 * Les coordonnées de la société et le numéro de TVA doivent figurer sur TOUTES
 * les pages du site, pas seulement sur les pages juridiques — exigence rappelée
 * par un contrôleur de la Région wallonne. Le poser ici plutôt que page par page
 * garantit qu'une page ajoutée demain l'aura aussi.
 *
 * Le catalogue (/shop) fait exception : sa mise en page occupe exactement la
 * hauteur de l'écran et défile en interne, le pied de page y est donc placé au
 * bas de sa propre zone de défilement.
 */

import { Outlet, useLocation } from 'react-router-dom';
import EcommerceFooter from './EcommerceFooter';
import { useCanonical } from '../../../hooks/useCanonical';

export default function ShopFooterLayout() {
  // Chaque page de la boutique déclare sa propre adresse à Google (le
  // catalogue /shop, hors de cette enveloppe, gère la sienne).
  const { pathname } = useLocation();
  useCanonical(pathname);
  return (
    <div className="min-h-screen flex flex-col">
      {/* <main> : le repère qui permet de SAUTER l'en-tête et le menu. Posé ici,
          au niveau de l'enveloppe de route, toutes les pages de la boutique en
          héritent — y compris celles qu'on ajoutera demain. L'audit du
          15/09/2026 n'en trouvait aucun sur les quatre pages mesurées : la même
          en-tête était relue à chaque navigation. */}
      <main className="flex-1">
        <Outlet />
      </main>
      <EcommerceFooter />
    </div>
  );
}
